import React from "react";
import { ErrorMessage } from "formik";

const withError = (Component) => (props) => {
  const { field } = props;

  return (
    <div>
      <Component {...props} />
      <ErrorMessage
        name={field.name}
        component="div"
        className="form-error-message"
      />
    </div>
  );
};

export default withError;



// WEBPACK FOOTER //
// ./src/components/hocs/withError.jsx